import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/components/shared";
import { ShieldCheck } from "@phosphor-icons/react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="p-6 lg:p-8 max-w-[1200px] animate-fade-in">
      <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-600 font-bold mb-1">Administration</div>
      <h1 className="font-heading text-3xl font-black tracking-tight text-zinc-50 mb-6 flex items-center gap-2"><ShieldCheck size={28} className="text-emerald-600" /> Audit Log</h1>
      <div className="border-l border-zinc-800 ml-2 space-y-4">
        {logs.map((a) => (
          <div key={a.id} className="relative pl-6" data-testid={`audit-${a.id}`}>
            <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 bg-emerald-600 rounded-full" />
            <div className="flex items-center gap-3 flex-wrap">
              <span className="text-sm text-zinc-100 capitalize font-medium">{a.action.replace(/_/g, " ")}</span>
              {a.details?.title && <span className="text-xs text-zinc-500">— {a.details.title}</span>}
            </div>
            <div className="text-xs font-mono text-zinc-500 mt-0.5">{a.user_name} · {fmtDate(a.at)}</div>
          </div>
        ))}
        {logs.length === 0 && <div className="pl-6 text-zinc-500 text-sm">No activity yet.</div>}
      </div>
    </div>
  );
}
